<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
            <c-form-item type="input" label="版本号" name="version"></c-form-item>
            <c-form-item type="select" label="所属项目" name="app_type" :options="appType"></c-form-item>
            <c-form-item type="select" label="系统" name="system" :options="systemType"></c-form-item>
            <c-form-item type="select" label="版本类型" name="version_type" :options="versionType"></c-form-item>
            <c-form-item type="checkbox" label="状态" name="state" :options="appState" column="2"></c-form-item>
        </c-form>
			</m-search>
			<m-operate>
			      <c-button color="sys" icon="add" power="b_app_version_add" @click="navigateTo(`/app_version_add`)">发布新版本</c-button>
      </m-operate>
			<c-table ref="table" code="app_version_list">
				<c-table-column label="状态" name="state" width="50">
					<template v-slot="{data}">
            <span v-if="data.state == 1" style="color:red">{{stateName[data.state]}}</span>
            <span v-if="data.state == 2" style="color:green">{{stateName[data.state]}}</span>
          </template>
				</c-table-column>
				<c-table-column label="版本类型" name="version_type" width="50">
				    <template v-slot="{data}">{{versionTypeName[data.version_type]}}</template>
				</c-table-column>
				<c-table-column label="版本号" name="version" width="90"></c-table-column>
				<c-table-column label="版本代号" name="version_code" width="50"></c-table-column>
                <c-table-column label="所属项目" name="app_type" width="80">
				    <template v-slot="{data}">{{appTypeName[data.app_type]}}</template>
				</c-table-column>
				<c-table-column label="接口版本" name="project_version" width="70"></c-table-column>
				<c-table-column label="系统类型" name="system" width="50"></c-table-column>
				<c-table-column label="更新内容" name="remark" width="180"></c-table-column>
				<c-table-column label="创建时间" name="create_date" width="100"></c-table-column>
				<c-table-column label="启/禁用状态" name="is_enable" width="70">
          <template v-slot="{data}">
            <span v-if="data.is_enable == 2" style="color:red">{{enableTypeName[data.is_enable]}}</span>
            <span v-if="data.is_enable == 1" style="color:green">{{enableTypeName[data.is_enable]}}</span>
          </template>
				</c-table-column>

				<c-table-column type="button" fixed="right" label="操作">
            <template v-slot="{data}">
              <c-table-button v-if="data.state == 1" power="b_app_version_edit" @click="navigateTo(`/app_version_edit/${data.id}`)">编辑</c-table-button>
                <c-table-button v-if="data.state == 1" power="b_app_version_release" @click="release(data)">发布</c-table-button>
                <c-table-button v-if="data.state == 1" power="b_app_version_del" @click="del(data)">删除</c-table-button>
                <c-table-button v-if="data.state == 2 && data.is_enable == 2" power="b_app_version_state" @click="editState(data,1)">启用</c-table-button>
                <c-table-button v-if="data.state == 2 && data.is_enable == 1" power="b_app_version_state" @click="editState(data,2)">禁用</c-table-button>
                <c-table-button v-if="data.state == 2" power="b_app_version_state" @click="downloadAPP(data)">复制下载地址</c-table-button>
            </template>
        </c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_app_version',
		data() {
			return {
        stateName: {
            1: '草稿',
            2: '已发布'
        },
			  appTypeName: {
            10: '批发平台APP'
        },
			  versionTypeName: {
            1: '内测',
            2: '公开'
        },
				appState: [
                   {name: '草稿',value: 1},
                   {name: '已发布',value: 2}
                ],
				appType: [
                    {name: '批发平台APP',value: 10}
				],
				systemType: [
                    {name: 'IOS',value: 'IOS'},
                    {name: 'Android',value:'Android'}
				],
				versionType: [
                    {name: '内测',value:1},
                    {name: '公开',value:2}
				],
				enableTypeName: {
                    1: '启用',
                    2: '禁用'
        }
			}
		},
		
		mounted() {
			this.$refs.search.search();
			// 例如在列表页定义一个方法，第一个参数为方法名，为了防止出现命名冲突，以{页面名.方法名}的结构命名
            this.$bus.$on('app_version_list.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/app/version/list',
					data
				});
			},
			/**删除**/
      del(data) {
          this.$confirm({
                  text: '确定要删除APP版本【'+data.version+'】吗？',  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: true,  // 是否显示取消按钮
                  resolve: () => {
                       this.request({
                           url: '/app/version/remove',
                           data: {
                               version_id: data.id
                           },
                           loading: true,
                           success: data => {
                               this.$message({
                                   text: '删除成功'
                               });
                               this.$refs.search.search();
                           }
                        });
                  },  // 确定按钮回调
                  cancel: () => {},  // 取消按钮回调
              });
      },
      /**发布**/
      release(data) {
          this.$confirm({
                  text: '确定要发布APP版本【'+data.version+'】吗？',  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: true,  // 是否显示取消按钮
                  resolve: () => {
                       this.request({
                           url: 'app/version/publish',
                           data: {
                               version_id: data.id
                           },
                           loading: true,
                           success: data => {
                               this.$message({
                                   text: '发布成功'
                               });
                               this.$refs.search.search();
                           }
                        });
                  },  // 确定按钮回调
                  cancel: () => {},  // 取消按钮回调
              });
      },
      /**模板启禁用**/
      editState(data,is_enable) {
          this.$confirm({
                  text: '确定要'+(is_enable == 1 ? '启用' : '禁用')+'版本【'+data.version+'】吗？',  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: true,  // 是否显示取消按钮
                  resolve: () => {
                       this.request({
                           url: '/app/version/edit/enable',
                           data: {
                               version_id: data.id,
                               is_enable:is_enable
                           },
                           loading: true,
                           success: result => {
                               this.$message({
                                   text: (is_enable == 1 ? '启用' : '禁用')+'成功'
                               });
                               data.is_enable = is_enable;
                               //刷新列表
                               // this.$refs.table.update();
                           }
                        });
                  },  // 确定按钮回调
                  cancel: () => {},  // 取消按钮回调
              });
      },
      downloadAPP(data) {
          this.clipboard(data.app_download_url, '下载地址已复制到剪贴板');
      }
		}
	}
</script>